module.exports = __webpack_public_path__ + "static/img/law-c.9f98a5b4.png";